export const ALL_RARITY = [
  "AR",
  "BR",
  "CR",
  "FR",
  "HR",
  "LSR",
  "MR",
  "MTR",
  "N",
  "OR",
  "PR",
  "PTR",
  "PU",
  "R",
  "SC",
  "SCR",
  "SE",
  "SGR",
  "SP",
  "SR",
  "SSR",
  "TGR",
  "TR",
  "UGR",
  "UR",
  "USR",
  "XR",
  "ZR",
];

export const CARD_TYPE = {
  card: "卡片",
  fragment: "碎片",
  gems: "Gems",
  free_draw: "免费抽卡次数",
  miss: "Miss",
};

export const PACK_TYPE = {
  free: "免费抽卡",
  star: "Star抽卡",
  gems: "Gems抽卡",
};

export const POINTLOG_TYPE = {
  sign_up: "注册赠送",
  by_manager: "管理员操作",
  draw_card: "抽卡",
  exchange_card: "卡片兑换积分",
};
